export const NEW_API_ENTRYPOINT = `https://donesido.oue.app/method/`;
export const NEW_API_VERSION = `1.0`;
export const DONESIDO_LOCAL_STORAGE_PREFIX = `dd_city_`;

export const OLD_LOGGED_BOOL_PLACEHOLDER = true;
